<script> 
	import { 
		headerTitleHome, 
		linkAV,
		linkAV2,
		linkAreaCliente,
		linkConheca,
		linkSolicite,
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkPesquisaVendasVideo,
		linkInstagram,
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Instagram				from '../components/Instagram.svelte'

	import Boleto           		from '../components/Boleto.svelte'
	import PopUp					from '../components/PopUp.svelte'
	import Videos					from "../components/Videos.svelte";  
	import Busca					from '../components/Busca.svelte'
	import ListaImoveis				from '../components/ListaImoveis.svelte'
	import Vitrine					from '../components/Vitrine.svelte'

	let vitrines = [
		{
			image: 'vitrineLocaFacil.jpg', 
			imageMobile: 'vitrineLocaFacilM.jpg', 
			title: 'Loca fácil Zimmer',
			href: '/locafacil'
		},
		{
			image: 'vitrineCarencia.jpg', 
			imageMobile: 'vitrineCarenciaM.jpg', 
			title: 'Carência Zimmer',
			href: '/carencia'
		},
	];
	
	function toggleMenu() {
		document.querySelector('header.header--hidden').classList.toggle('hidden');
	}

	function search(e) {
		const filters = {...e.detail, ...{ordem:'1'}};
		const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(filters).filter(p=>p[1].toString().length>0&&(p[1].toString()!='0'||p[0]=='ordem')).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}

	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1, destaque: true, tem_foto: 1};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:6, random: 1, destaque: true, tem_foto: 1};
	let filtrosVideos = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:12, random: 1, RealtySearchCustomTemVideo: 1};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			});
		}, 500);
	}

	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<Vitrine vitrines={vitrines} showDots={true} showArrows={false} vitrineHeight="500px"/>

<section class="busca">
	<div class="container">	
		<Busca on:filter={search} />
	</div>
</section>


<!-- Destaques Vendas -->
<section class="section destaques-home destaques-home--vendas" style="display: none;">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title color-secondary">
					<a href="{$linkPesquisaVendas}" class="color-primary">Compra e Venda</a> de lançamentos e seminovos
				</h2>
				<div class="flex-1 hidden-sm hidden-xs text-right">
				</div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaVendas}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-primary"></i></a>
		</div>
	</div>
</section>

<section class="section info aplicativo background-gray">
	<a name="aplicativo"></a>
	<div class="container ">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top  hidden-lg hidden-md" style="background-image: url('assets/images/mockup.png')"></div>
			<div class="content flex-1 flex flex-column gap-20">
				<div class="flex flex-column flex-start">
					<h2 class="header inline">Aplicativo <span class="color-accent">Zimmer Digital</span></h2>
					<p>Todos os serviços em um único lugar!<br />Utilize no seu celular, tablet ou computador.<br />Comunicação rápida, prática e segura.</p>
					<div class="flex flex-start gap-10">
						<a href="{$linkConheca}" target="_blank" class="btn btn-secondary">SAIBA MAIS</a>
						<a href="{$linkAV}" target="_blank" class="btn btn-primary">ACESSE AGORA</a>
					</div>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/mockup.png')"></div>
		</div>
	</div>
</section>

<!-- Destaques Alugar -->
<section class="section destaques-home destaques-home--locacao" style="display: none;">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title">
					<a href="{$linkPesquisaLocacao}" class="color-primary">Aluguel</a> residencial e comercial
				</h2>
				<div class="flex-1 hidden-sm hidden-xs text-right">
				</div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaLocacao}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-primary"></i></a>
		</div>
	</div>
</section>

<section class="section section-social" style="display: none;">
	<div class="container">
		<div class="header">
			<h2 class="title text-center">
				<a href="{$linkInstagram}" target="_blank" class="color-secondary">@imobiliariazimmer</a> nas redes sociais
			</h2>
		</div>
	</div>
	<Instagram />
</section>

<PopUp channel="site" />